import script from "./ArtworkPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtworkPanel.vue?vue&type=script&setup=true&lang=js"

import "./ArtworkPanel.vue?vue&type=style&index=0&id=55f0583d&scoped=true&lang=less"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f0583d"]])

export default __exports__